import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import concreteFloor from "./components/concrete-floor";
import timberframeFloor from "./components/timberframe-floor";
import cltFloor from "./components/clt-floor";

const principle: Slide = {
  description:
    "Choose between airborne and impact sound insulation of floors. Select different floors. See how they are constructed and what their sound reduction index is. Listen to everyday sounds in their original form and as they would be perceived through a floor. Use headphones. Set the volume on your device so that original male voice sounds realistically loud.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 9],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<strong>airborne insulation</strong>",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                    fontSize: "14px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "controlsToggleExtraContent",
              options: {
                controlsPosition: "top",
                controls: [
                  {
                    type: "button",
                    options: {},
                    items: [{ name: "Concrete floor" }, { name: "Timberframe floor" }, { name: "CLT floor" }],
                  },
                ],
                extraContent: [[], [], []],
                components: [concreteFloor, timberframeFloor, cltFloor],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
